<ng-container *ngIf="render$ | async" />

<div class="w-full h-full flex flex-row items-stretch" cslPerfectScrollbar>
  <div class="p-4 flex flex-col space-y-4 items-stretch basis-[350px]" cslPerfectScrollbar>
    <div class="mat-body-2" i18n>Верхний левый</div>
    <csl-angle-settings
      data-testid="tl"
      dense
      [outlineOptions]="userOptions.outlineEditorOptions"
      [disabled]="!editable"
      [panel]="panel"
      [angleProcessingAvailability]="angleProcessingAvailability"
      [anglePosition]="'tl'"
      [materialType]="materialType"
      (anglesChange)="formChanged.next($event)">
    </csl-angle-settings>

    <div class="mat-body-2" i18n>Нижний левый</div>
    <csl-angle-settings
      data-testid="bl"
      dense
      [outlineOptions]="userOptions.outlineEditorOptions"
      [disabled]="!editable"
      [panel]="panel"
      [angleProcessingAvailability]="angleProcessingAvailability"
      [anglePosition]="'bl'"
      [materialType]="materialType"
      (anglesChange)="formChanged.next($event)">
    </csl-angle-settings>
  </div>

  <div cslPerfectScrollbar class="p-4 schema-wrapper flex flex-col items-start flex-1">
    <div i18n *ngIf="growthOfPanelSize > 0" class="growth-of-panel-size">
      Размер детали будет увеличен на {{ growthOfPanelSize }} мм
    </div>
    <csl-svg-workspace class="m-auto" #svgWorkspace [p]="panel"></csl-svg-workspace>
  </div>

  <div class="p-4 flex flex-col space-y-4 items-stretch basis-[350px]" cslPerfectScrollbar>
    <div class="mat-body-2" i18n>Верхний правый</div>
    <csl-angle-settings
      data-testid="tr"
      dense
      [outlineOptions]="userOptions.outlineEditorOptions"
      [disabled]="!editable"
      [panel]="panel"
      [angleProcessingAvailability]="angleProcessingAvailability"
      [anglePosition]="'tr'"
      [materialType]="materialType"
      (anglesChange)="formChanged.next($event)">
    </csl-angle-settings>

    <div class="mat-body-2" i18n>Нижний правый</div>
    <csl-angle-settings
      data-testid="br"
      dense
      [outlineOptions]="userOptions.outlineEditorOptions"
      [disabled]="!editable"
      [panel]="panel"
      [angleProcessingAvailability]="angleProcessingAvailability"
      [anglePosition]="'br'"
      [materialType]="materialType"
      (anglesChange)="formChanged.next($event)">
    </csl-angle-settings>
  </div>
</div>

